import { GenerateQueriesArgs, generateQueries } from 'src/queries/queryGenerator'
import {
  DispatchOrderItems,
  DispatchOrderItemsPayload,
  DispatchOrderItemsQueryParams,
} from 'src/types'

export const DISPATCH_ORDER_ITEMS_ENDPOINT = 'dispatch_orderitems'
export const DISPATCH_ORDER_ITEMS_QUERY_KEY = 'dispatch_orderitems'

const generateQueriesConfig: GenerateQueriesArgs<
  DispatchOrderItems & { id?: Id }, //There is a typing issue if the entity does not have an id. To investigate.
  DispatchOrderItemsQueryParams,
  DispatchOrderItemsPayload
> = {
  endpoint: DISPATCH_ORDER_ITEMS_ENDPOINT,
  queryKey: DISPATCH_ORDER_ITEMS_QUERY_KEY,
}

export const {
  usePutEntity: usePutDispatchOrderItems,
  useRecursiveQuery: useRecursiveDispatchOrderItemsQuery,
  useSingleEntityQuery: useDispatchOrderItemQuery,
} = generateQueries(generateQueriesConfig)
